"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var School_exports = {};
__export(School_exports, {
  default: () => School_default
});
module.exports = __toCommonJS(School_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 19 18",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.51953 5.83203C8.93359 5.83203 8.43229 6.04036 8.01562 6.45703C7.59896 6.8737 7.39062 7.38151 7.39062 7.98047C7.39062 8.56641 7.59896 9.06771 8.01562 9.48438C8.43229 9.90104 8.93359 10.1094 9.51953 10.1094C10.1185 10.1094 10.6263 9.90104 11.043 9.48438C11.4596 9.06771 11.668 8.56641 11.668 7.98047C11.668 7.38151 11.4596 6.8737 11.043 6.45703C10.6263 6.04036 10.1185 5.83203 9.51953 5.83203ZM9.51953 9.13281C9.20703 9.13281 8.93359 9.02214 8.69922 8.80078C8.47786 8.56641 8.36719 8.29297 8.36719 7.98047C8.36719 7.65495 8.47786 7.38151 8.69922 7.16016C8.93359 6.9388 9.20703 6.82812 9.51953 6.82812C9.84505 6.82812 10.1185 6.9388 10.3398 7.16016C10.5612 7.38151 10.6719 7.65495 10.6719 7.98047C10.6719 8.29297 10.5612 8.56641 10.3398 8.80078C10.1185 9.02214 9.84505 9.13281 9.51953 9.13281ZM16.5117 10.7734H14.5586V7.16016L14.7344 7.25781C14.7734 7.28385 14.8125 7.30339 14.8516 7.31641C14.8906 7.32943 14.9297 7.33594 14.9688 7.33594C15.0599 7.33594 15.1445 7.31641 15.2227 7.27734C15.3008 7.22526 15.3594 7.15365 15.3984 7.0625C15.4635 6.94531 15.4766 6.82161 15.4375 6.69141C15.3984 6.5612 15.3203 6.46354 15.2031 6.39844L10.0273 3.625C10.0273 3.61198 10.0273 3.59896 10.0273 3.58594C10.0273 3.57292 10.0273 3.5599 10.0273 3.54688C10.0273 3.44271 10.0273 3.31901 10.0273 3.17578C10.0273 3.03255 10.0273 2.88932 10.0273 2.74609V2.72656H11.5703C11.7135 2.72656 11.8372 2.68099 11.9414 2.58984C12.0456 2.48568 12.0977 2.36198 12.0977 2.21875V1.41797C12.0977 1.28776 12.0456 1.17057 11.9414 1.06641C11.8372 0.96224 11.7135 0.910156 11.5703 0.910156H9.53906C9.47396 0.910156 9.40885 0.923177 9.34375 0.949219C9.29167 0.97526 9.23958 1.01432 9.1875 1.06641C9.13542 1.11849 9.09635 1.17708 9.07031 1.24219C9.04427 1.29427 9.03125 1.35938 9.03125 1.4375C9.04427 1.93229 9.05078 2.36849 9.05078 2.74609C9.05078 3.1237 9.05078 3.41016 9.05078 3.60547L3.85547 6.39844C3.72526 6.46354 3.64062 6.5612 3.60156 6.69141C3.5625 6.82161 3.57552 6.94531 3.64062 7.0625C3.69271 7.15365 3.75781 7.22526 3.83594 7.27734C3.91406 7.31641 3.9987 7.33594 4.08984 7.33594C4.12891 7.33594 4.16797 7.32943 4.20703 7.31641C4.24609 7.30339 4.28516 7.28385 4.32422 7.25781L4.5 7.16016V10.7734H2.48828C2.35807 10.7734 2.24089 10.8255 2.13672 10.9297C2.04557 11.0208 2 11.1315 2 11.2617V16.1641C2 16.2943 2.04557 16.4115 2.13672 16.5156C2.24089 16.6068 2.35807 16.6523 2.48828 16.6523H16.5117C16.6419 16.6523 16.7526 16.6068 16.8438 16.5156C16.9479 16.4115 17 16.2943 17 16.1641V11.2617C17 11.1315 16.9479 11.0208 16.8438 10.9297C16.7526 10.8255 16.6419 10.7734 16.5117 10.7734ZM2.99609 15.6562V11.75H4.5V15.6562H2.99609ZM7.97656 15.6562V13.4102H11.082V15.6562H7.97656ZM12.0586 15.6562V12.9023C12.0586 12.7721 12.0065 12.6615 11.9023 12.5703C11.8112 12.4661 11.7005 12.4141 11.5703 12.4141H7.48828C7.34505 12.4141 7.22786 12.4661 7.13672 12.5703C7.04557 12.6615 7 12.7721 7 12.9023V15.6562H5.49609V6.65234L9.51953 4.46484L9.57812 4.50391L13.5625 6.65234V15.6562H12.0586ZM16.0039 15.6562H14.5586V11.75H16.0039V15.6562Z",
      fill: "currentColor"
    }
  )
);
const SvgSchool = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var School_default = SvgSchool;
